<template>
  <el-row>
    <el-col>
      <el-form
        data-v-step="measurementPoint"
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-row class="point-container">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item
              :label="$t('tree.pointName')"
              prop="name"
              label-width="45%"
            >
              <el-input
                v-model="form.name"
                @keyup.enter.native="save"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('tree.tagCode')"
              style="display: none"
              label-width="45%"
              prop="tagCode"
            >
              <el-input
                v-model="form.tagCode"
                @input="sanitize($event)"
                @keyup.enter.native="save"
              >
                <span slot="prefix">$</span>
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('tree.positionOfSensor')"
              label-width="45%"
            >
              <el-select
                clearable
                filterable
                autocomplete
                multiple
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.type"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in pointTypes"
                  :key="item"
                  :label="$t(`pointType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="form.type.includes('GearBox')"
              :label="$t('tree.gearBoxConversionRate')"
              label-width="45%"
            >
              <el-input-number
                prop="gearboxConversionInput"
                size="mini"
                :controls="false"
                v-model="form.gearboxConversionInput"
                :min="0"
              />
              /
              <el-input-number
                style="margin-left: 10px"
                prop="gearboxConversionOutput"
                size="mini"
                :controls="false"
                v-model="form.gearboxConversionOutput"
                :min="0"
              />
            </el-form-item>
            <el-form-item
              v-show="form.type.includes('GearBox')"
              :label="$t('tree.numberOfStages')"
              label-width="45%"
            >
              <el-input-number
                prop="numberOfStages"
                size="mini"
                :controls="false"
                v-model="form.numberOfStages"
                :min="0"
              />
            </el-form-item>
            <el-form-item
              v-show="form.type.includes('GearBox')"
              :label="$t('tree.gearboxType')"
              label-width="45%"
            >
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.gearboxType"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in gearboxTypes"
                  :key="item"
                  :label="$t(`gearboxType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType === 'planetaryGearReducer'
              "
              :label="$t('tree.numberOfGearTeethAtRingGear')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtRingGear"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType === 'planetaryGearReducer'
              "
              :label="$t('tree.numberOfGearTeethAtPlanetGear')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtPlanetGear"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType === 'planetaryGearReducer'
              "
              :label="$t('tree.numberOfGearTeethAtSunGear')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtSunGear"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType &&
                form.gearboxType !== 'planetaryGearReducer'
              "
              :label="$t('tree.shaftOfSensorAttachedTo')"
            >
              <el-select v-model="form.shaftOfSensorAttachedTo">
                <el-option
                  key="input"
                  :label="$t(`gearShaft.input`)"
                  value="input"
                ></el-option>
                <el-option
                  key="middle"
                  :label="$t(`gearShaft.middle`)"
                  value="middle"
                ></el-option>
                <el-option
                  key="output"
                  :label="$t(`gearShaft.output`)"
                  value="output"
                ></el-option>
              </el-select>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType &&
                form.gearboxType !== 'planetaryGearReducer'
              "
              :label="$t('tree.numberOfGearTeethAtDriverShaft')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtDriverShaft"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType &&
                form.gearboxType !== 'planetaryGearReducer' &&
                form.shaftOfSensorAttachedTo &&
                form.shaftOfSensorAttachedTo === 'middle'
              "
              :label="$t('tree.numberOfGearTeethAtFirstCurrentShaft')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtFirstCurrentShaft"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType &&
                form.gearboxType !== 'planetaryGearReducer' &&
                form.shaftOfSensorAttachedTo &&
                form.shaftOfSensorAttachedTo === 'middle'
              "
              :label="$t('tree.numberOfGearTeethAtSecondCurrentShaft')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtSecondCurrentShaft"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item
              v-show="
                form.type.includes('GearBox') &&
                form.gearboxType &&
                form.gearboxType !== 'planetaryGearReducer'
              "
              :label="$t('tree.numberOfGearTeethAtDrivenShaft')"
            >
              <el-input-number
                v-model="form.numberOfGearTeethAtDrivenShaft"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px"></span>
            </el-form-item>
            <el-form-item :label="$t('tree.machineType')" label-width="45%">
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.machineType"
                @change="removeEmptyData('pump');removeEmptyData('coupling');"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in machineTypes"
                  :key="item"
                  :label="$t(`machineType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>

    <!--Pump -->
    <el-form-item label-width="45%" :label="$t('machineType.pump')" v-show="form.machineType==='pump'">
      <el-select
                clearable 
                default-first-option
                value-key="item"
                v-model="form.pump"
                v-bind="form.pump"
                :placeholder="$t('tree.selectType')"
                @change="removeEmptyData(form.pump)"
              >
                <el-option
                   v-for="item in pump"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`pumpType.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>

    <el-form-item label-width="45%" :label="$t(`pumpType.${form.pump}`)" v-show="form.machineType==='pump' && form.pump">
      <el-select
                clearable
                default-first-option
                value-key="item"
                v-model="form[form.pump]"
                @change="removeEmptyData(form[form.pump])"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                   v-for="item in this[form.pump]"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`${form.pump}.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>

    <el-form-item label-width="45%" :label="$t(`${form.pump}.${form[form.pump]}`)" v-show="form.machineType==='pump' && form.pump && form[form.pump]">
      <el-select
                clearable
                filterable
                allow-create
                default-first-option
                value-key="item"
                v-model="form[form[form.pump]]"
                @change="removeEmptyData(form[form[form.pump]])"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                   v-for="item in this[form[form.pump]]"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`${form[form.pump]}.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>

   

    <!--Pump -->

    <!-- Coupling-->

    <el-form-item label-width="45%" :label="$t('machineType.Coupling')" v-show="form.machineType==='Coupling'" >
      <el-select
                clearable
                default-first-option
                value-key="item"
                v-model="form.coupling"
                @change="removeEmptyData(form.coupling)"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                   v-for="item in coupling"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`coupling.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>

    <el-form-item label-width="45%" :label="$t(`coupling.${form.coupling}`)" v-show="form.coupling && form.machineType==='Coupling'">
      <el-select
                clearable
                default-first-option
                value-key="item"
                v-model="form[form.coupling]"
                @change="removeEmptyData(form[form.coupling])"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                   v-for="item in this[form.coupling]"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`${form.coupling}.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>
    <el-form-item label-width="45%" :label="$t(`${form.coupling}.${form[form.coupling]}`)" v-show="this[form[form.coupling]]">
      <el-select
                clearable
                default-first-option
                value-key="item"
                v-model="form[form[form.coupling]]"
                :placeholder="$t('tree.selectType')"
                @change="removeEmptyData(form[form[form.coupling]])"
              >
                <el-option
                   v-for="item in this[form[form.coupling]]"
                  :key="item.key"
                  :value="item.key"
                  :label="$t(`${form[form.coupling]}.${item.key}`)"
                ></el-option>
              </el-select>
              <br />
    </el-form-item>
  
    <!-- Coupling-->

            <el-form-item :label="$t('point.previousFaults')" label-width="45%">
              <el-select
                clearable
                filterable
                allow-create
                default-first-option
                value-key="item"
                multiple
                v-model="form.previousFaults"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in previousFaultsOptions"
                  :key="item"
                  :label="$t(`vibration_analyze_report.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
              <br />
            </el-form-item>
            <el-form-item :label="$t('tree.driveType')" label-width="45%">
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.driveType"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in driveTypes"
                  :key="item"
                  :label="$t(`driveType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="form.driveType == 'electricMotor'"
              :label="$t('tree.power')"
              label-width="45%"
            >
              <el-input-number
                v-model="form.motorPower"
                :min="0"
              ></el-input-number>
              <span style="margin-left: 10px; font-size: 16px">kW</span>
            </el-form-item>
            <el-form-item
              :label="$t('tree.transmissionType')"
              label-width="45%"
            >
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.transmissionType"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in transmissionTypes"
                  :key="item"
                  :label="$t(`transmissionType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="form.transmissionType == 'belt-pulley'"
              :label="$t('tree.beltType')"
              label-width="45%"
            >
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.beltType"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in beltTypes"
                  :key="item"
                  :label="$t(`beltType.${item}`)"
                  :value="item"
                ></el-option>
              </el-select>
            <el-form-item style="margin-top:20px;">
              <el-input-number
                style="height: 30px"
                prop="referenceFrequency"
                :controls="false"
                v-model="form.beltLength"
                :min="0"
              />
              cm
            </el-form-item>
            <el-form-item  style="margin-top:20px;"> <el-input-number v-model="form.pulleyRadiusRatio" prop="referenceFrequency" :controls="false" :min="0"/> Ratio</el-form-item>             
           
            </el-form-item>
           
            <el-form-item
              v-show="form.transmissionType == 'coupling'"
              :label="$t('tree.couplingType')"
              label-width="45%"
            >
              <el-select
                clearable
                filterable
                autocomplete
                collapse-tags
                allow-create
                default-first-option
                value-key="item"
                v-model="form.couplingType"
                :placeholder="$t('tree.selectType')"
              >
                <el-option
                  v-for="item in coupling"
                  :key="item.key"
                  :label="$t(`coupling.${item.key}`)"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('tree.referenceFrequency')"
              label-width="45%"
            >
              <el-input-number
                style="float: left; width: 140px"
                prop="referenceFrequency"
                size="medium"
                :value="form.referenceFrequency.toFixed(2)" @change="setReferenceFrequency"
                :min="0"
                :disabled="form.referenceFrequencyVariable"
              ></el-input-number>
              <div
                style="
                  float: left;
                  display: flex;
                  flex-direction: column;
                  height: 50px;
                  margin-left: 10px;
                "
              >
                <el-radio-group
                  v-model="freqType"
                  size="mini"
                  style="margin-left: 0px"
                >
                  <el-radio-button label="Frequency">{{
                    $t("chart.ftFrequency")
                  }}</el-radio-button>
                  <el-radio-button label="RPM">{{
                    $t("chart.fRPM")
                  }}</el-radio-button>
                </el-radio-group>
                <el-checkbox
                  style="margin-left: 10px"
                  v-model="form.referenceFrequencyVariable"
                  @change="referenceFrequencyVariable()"
                >
                  {{ $t("common.variable") }}</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('point.lastMaintenanceDate')">
              <el-date-picker
                size="mini"
                v-model="form.lastMaintenanceDate"
                type="date"
                :picker-options="pickerOptions"
                :format="pickerOptions.format"
              ></el-date-picker>
            </el-form-item>
            <div style="font-size: 18px">{{ $t("point.image") }}</div>
            <el-image
              v-show="!!image"
              fit="contain"
              :preview-src-list="[image]"
              :src="image"
              style="width: auto; height: 200px"
            >
              <div slot="error" class="image-slot"></div
            ></el-image>
            <el-image
              v-show="!image"
              style="width: auto; height: 200px; display: flex; display: block"
            >
              <div slot="error" class="image-slot"></div>
            </el-image>
            <br />
            <el-button @click="chooseFile">{{
              $t("point.chooseFile")
            }}</el-button>

            <input
              type="file"
              style="display: none"
              id="fileTitle"
              @change="loadFile()"
              ref="myFile"
            />
            <el-button
              type="danger"
              size="mini"
              style="margin-left: 10px"
              @click="clearInput()"
              icon="el-icon-delete"
              circle
            ></el-button>
            <h4 style="margin-left: 20px">
              {{ $t("tree.macthCoordinateAndSensorAxis") }}
            </h4>
            <el-row>
              <el-col :span="24" style="display: flex">
                <div>
                  <el-form-item
                    :label="$t('tree.coordinateXAxis')"
                    :inline-message="true"
                  >
                    <el-radio-group
                      size="mini"
                      style="margin: 0px"
                      v-model="form.coordinateXAxis"
                    >
                      <el-radio-button label="xAxis">
                        X {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="yAxis"
                        >Y {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="zAxis"
                        >Z {{ $t("alarms.axis") }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    :label="$t('tree.coordinateYAxis')"
                    :inline-message="true"
                  >
                    <el-radio-group
                      size="mini"
                      style="margin: 0px"
                      v-model="form.coordinateYAxis"
                    >
                      <el-radio-button label="xAxis">
                        X {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="yAxis"
                        >Y {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="zAxis"
                        >Z {{ $t("alarms.axis") }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    :label="$t('tree.coordinateZAxis')"
                    :inline-message="true"
                  >
                    <el-radio-group
                      size="mini"
                      style="margin: 0px"
                      v-model="form.coordinateZAxis"
                    >
                      <el-radio-button label="xAxis">
                        X {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="yAxis"
                        >Y {{ $t("alarms.axis") }}</el-radio-button
                      >
                      <el-radio-button label="zAxis"
                        >Z {{ $t("alarms.axis") }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>
                  <img
                    class="sensorAxis"
                    src="https://github.com/sensemore/sensemore-icon/blob/master/pointSensorAxisLigth.png?raw=true"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              v-show="form.type.includes('Bearing')"
              :label="$t('point.rulman_model')"
            >
              <el-select
                v-model="form.bearingBrand"
                clearable
                @change="bearingBrandChanged()"
                :placeholder="$t('point.selectBearingBrand')"
              >
                <el-option
                  v-for="item in bearingBrands"
                  :label="item.label"
                  :key="item.key"
                  :value="item.value"
                >
                  <span>{{ item.label }} </span>
                </el-option>
              </el-select>
              <el-select
                style="margin-left: 10px"
                :disabled="!form.bearingBrand"
                clearable
                allow-create
                filterable
                remote
                @change="bearingChange"
                v-model="form.bearing"
                value-key="_id"
                :remote-method="filterBearing"
                :loading="bearingLoading"
                :placeholder="$t('point.selectBearingNumber')"
              >
                <el-option
                  v-for="item in bearings"
                  :label="item.label"
                  :key="item.key"
                  :value="item.value"
                >
                  <span
                    >{{ item.label }}
                    <span style="float: right">{{
                      $t("point.type_" + item.value.type.toLowerCase())
                    }}</span></span
                  >
                </el-option>
              </el-select>
              <em v-show="showNewModel" style="font-size: 14px">
                ( {{ $t("point.newModel") }} )
              </em>
              <el-col :span="24" style="margin-top: 10px">
                <el-collapse v-model="activeNames">
                  <el-collapse-item :title="$t('point.bearingDetail')" name="1">
                    <div>
                      <el-form
                        label-position="top"
                        ref="bearing"
                        class="bearing-form"
                      >
                        <el-col :span="8">
                          <el-form-item prop="bearing.bpfo">
                            <span slot="label">
                              {{ $t("point.bpfo") }}
                              <el-tooltip
                                :content="$t(`point.bpfo.info`)"
                                placement="top"
                              >
                                <em class="el-icon-info"></em>
                              </el-tooltip>
                            </span>
                            <el-input
                              v-model="form.bearing.bpfo"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 100px"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="bearing.bsf">
                            <span slot="label">
                              {{ $t("point.bsf") }}
                              <el-tooltip
                                :content="$t(`point.bsf.info`)"
                                placement="top"
                              >
                                <em class="el-icon-info"></em>
                              </el-tooltip>
                            </span>
                            <el-input
                              v-model="form.bearing.bsf"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 100px"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="bearing.bpfi">
                            <span slot="label">
                              {{ $t("point.bpfi") }}
                              <el-tooltip
                                :content="$t(`point.bpfi.info`)"
                                placement="top"
                              >
                                <em class="el-icon-info"></em>
                              </el-tooltip>
                            </span>
                            <el-input
                              v-model="form.bearing.bpfi"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 100px"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            prop="bearing.ftf"
                            v-show="form.bearing.ftf"
                          >
                            <span slot="label">
                              {{ $t("point.ftf") }}
                              <el-tooltip
                                :content="$t(`point.ftf.info`)"
                                placement="top"
                              >
                                <em class="el-icon-info"></em>
                              </el-tooltip>
                            </span>
                            <el-input
                              v-model="form.bearing.ftf"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 100px"
                            >
                            </el-input>
                          </el-form-item>
                          <el-form-item
                            prop="bearing.ftfi"
                            v-show="form.bearing.ftfi"
                          >
                            <span slot="label">
                              {{ $t("point.ftfi") }}
                              <el-tooltip
                                :content="$t(`point.ftfi.info`)"
                                placement="top"
                              >
                                <em class="el-icon-info"></em>
                              </el-tooltip>
                            </span>
                            <el-input
                              v-model="form.bearing.ftfi"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 100px"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            :label="$t('point.group')"
                            prop="bearing.group"
                          >
                            <el-input
                              v-model="form.bearing.group"
                              :disabled="form.bearing.type == 'DEFAULT'"
                              style="width: 300px"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-form>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item v-show="checkPermission('createPoint')">
          <el-button type="primary" @click="save()">{{
            $t("tree.create")
          }}</el-button>
          <el-button @click="cancel()">{{ $t("tree.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import bearingSpecificationService from "../service/bearingSpesifications";
import pointTypes from "../util/pointTypes";
import machineTypes from "../util/machineType";
import driveTypes from "../util/driveType";
import transmissionTypes from "../util/transmissionType";
import beltTypes from "../util/beltType";
import gearboxTypes from "../util/gearboxType";
import previousFaultsOptions from "../util/faultTypes";
import * as pumpTypes from "../util/Pump/pumpTypes"
import * as couplingTypes from '../util/Coupling/couplingTypes'
import preferences from "../util/preferences";
import dayjs from "dayjs-ext";

export default {
  name: "create-point",
  events: ["created", "cancelled"],
  props: ["parentGroupId"],
  data() {
    return {
      freqType: "Frequency",
      bearings: [],
      bearingLoading: false,
      bearingDetail: false,
      showNewModel: false,
      activeNames: ["1"],
      image: "",
      responseData: "",
      pulleyRadiusRatio:0,
      previousFaultsOptions: previousFaultsOptions,
      bearingBrands: [
        { key: "SCHAFFLER", label: "Schaffler", value: "SCHAFFLER" },
        { key: "SKF", label: "SKF", value: "SKF" },
        { key: "NTN", label: "NTN", value: "NTN" },
      ],
      pickerOptions: {
        format: preferences()
          .localization.dateFormat.replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
      },
      form: {
        lastMaintenanceDate: "",
        name: "",
        imageBool: false,
        tagCode: "",
        bearing: "",
        bearingBrand: "",
        type: ["None"],
        referenceFrequency: 0,
        imageName: "",
        coordinateXAxis: "",
        coordinateYAxis: "",
        coordinateZAxis: "",
        previousFaults: [],
        machineType: "",
        driveType: "",
        motorPower: 0,
        transmissionType: "",
        referenceFrequencyVariable: false,
        beltType: "",
        beltLength: 0,
        pulleyRadiusRatio:0,
        gearboxConversionInput: 0,
        gearboxConversionOutput: 0,
        numberOfStages: 0,
        gearboxTypes: "",
        pump:"",
        rotodynamic:"",
        positiveDisplacement:"",
        centrifugal:"",
        mixedFlow:"",
        axialFlow:"",
        rotary:"",
        reciprocating:"",
        open:"",
        coupling:"",
        rigid:"",
        flexible:"",
        mechanical:"",
        elastomeric:"",
        membrane:""
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("tree.pleaseInputName"),
            trigger: "blur",
          },
        ],
      },
      pointTypes: pointTypes,
      machineTypes: machineTypes,
      driveTypes: driveTypes,
      transmissionTypes: transmissionTypes,
      coupling: couplingTypes.couplingTypes,
      beltTypes: beltTypes,
      gearboxType: gearboxTypes,
      pump:pumpTypes.pumpTypes,
      rotodynamic:pumpTypes.rotoDynamics,
      centrifugal:pumpTypes.centrifugals,
      mixedFlow:pumpTypes.mixedFlows,
      axialFlow:pumpTypes.axialFlows,
      positiveDisplacement:pumpTypes.positiveDisplacements,
      rotary:pumpTypes.rotarys,
      reciprocating:pumpTypes.reciprocatings,
      open:pumpTypes.opens,
      coupling:couplingTypes.couplingTypes,
      rigid:couplingTypes.rigids,
      flexible:couplingTypes.flexibles,
      mechanical:couplingTypes.mechanicals,
      elastomeric:couplingTypes.elastomerics,
      membrane:couplingTypes.membranes
    };
  },
  computed: {
    ...mapState("account", ["activeTab"]),
  },
  methods: {
    setReferenceFrequency(value){
      console.log('sa',value  )
      this.form.referenceFrequency = value;
    },
    removeEmptyData(path){
      if(!path==undefined || !path==''){
        this.form[path]=''
      }
    },
     ...mapActions("account", ["changeTab"]),
    setChildSelect(value){
      
    },
    referenceFrequencyVariable() {
      if (this.form.referenceFrequencyVariable) {
        this.form.referenceFrequency = 0;
      }
    },
    async loadFile() {
      if (this.$refs.myFile.files && this.$refs.myFile.files[0]) {
        this.image = URL.createObjectURL(this.$refs.myFile.files[0]);
      }
      this.form.imageName = this.$refs.myFile.files[0].name;
      let temporary = this.image;
      this.form.imageBool = !!this.image;
      this.image = !this.image;
      this.image = temporary;
    },
    clearInput() {
      this.image = "";
      this.form.imageBool = false;
      this.$refs.myFile.value = "";
    },
    bearingChange(value) {
      if (!value.bearing_number) {
        this.showNewModel = true;
        this.bearingDetail = true;
        this.form.bearing = {
          bearing_number: value,
          bpfo: 0,
          bsf: 0,
          bpfi: 0,
          ftf: 0,
          group: "",
          type: "CUSTOM",
        };
      } else {
        this.showNewModel = false;
      }
    },
    filterBearing(query) {
      if (query !== "") {
        this.bearingLoading = false;
        bearingSpecificationService
          .getSpecs({ bearing_number: query, brand: this.form.bearingBrand })
          .then((d) => {
            this.bearings = [
              ...d.bearings.map((x) => {
                return {
                  value: x,
                  label: x.bearing_number,
                  key: x._id,
                };
              }),
            ];
          })
          .finally(() => {
            this.bearingLoading = false;
          });
      } else {
        this.bearings = [];
      }
    },
    ...mapActions("account", ["changeTab"]),
    cancel() {
      this.$emit("cancelled", null);
    },
    sanitize(tagCode) {
      this.form.tagCode = tagCode
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z 0-9]/g, "");
    },
    postUploadAWS(response) {
      if (!!response.data.S3URL && !!this.image) {
        var bodyFormData = new FormData();
        for (const [key, value] of Object.entries(response.data.S3URL.fields)) {
          bodyFormData.append(key, value);
        }
        bodyFormData.append("file", this.$refs.myFile.files[0]);
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        axios
          .post(`${response.data.S3URL.url}`, bodyFormData, config)
          .catch((e) => console.log(e));
      }
    },
    save() {
      if (this.freqType == "RPM") {
        this.form.referenceFrequency = this.form.referenceFrequency / 60;
        this.freqType = "Frequency";
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.lastMaintenanceDate = dayjs(
            this.form.lastMaintenanceDate
          ).format("YYYY-MM-DD HH:mm:ss");
          axios
            .post(
              `${process.env.VUE_APP_APIURL}/group/${this.parentGroupId}/point`,
              this.form
            )
            .then((response) => {
              this.postUploadAWS(response);
              this.$emit("created", {
                _id: response.data._id,
                tagCode: this.form.name.toUpperCase().replace(/" "/g, "-"),
                type: this.form.type,
                name: this.form.name,
                referenceFrequency: this.form.referenceFrequency.toFixed(2),
              });
            })
            .then(() => {
              this.image = "";
              this.form.imageBool = false;
              this.form.name = "";
              this.form.tagCode = "";
              this.form.bearing = "";
              this.form.bearingBrand = "";
              this.form.driveType = "";
              this.form.motorPower = 0;
              this.form.imageName = "";
              this.form.machineType=""
              this.form.transmissionType="";
              this.form.coupling = "";
              this.form.rigid="";
              this.form.flexible="";
              this.form.mechanical="";
              this.form.elastomeric="";
              this.form.membrane="";
              this.form.beltType = "";
              this.form.pulleyRadiusRatio=0;
              this.form.beltLength = 0;
              this.form.gearboxConversionInput = 0;
              this.form.gearboxConversionOutput = 0;
              this.form.numberOfStages = 0;
              this.form.gearboxTypes = "";
              this.form.previousFaults = [];
              this.form.lastMaintenanceDate = "";
              this.form.type = ["None"];
              this.form.referenceFrequency = 0;
              this.$refs["form"].resetFields();
            })
            .catch((e) => {
              this.$message.error(e);
            });
        }
      });
    },
    bearingBrandChanged() {
      this.form.bearing = "";
      this.bearings = [];
    },
    chooseFile() {
      this.$refs.myFile.click();
    },
  },
  watch: {
    freqType: function () {
      if (this.freqType == "Frequency") {
        this.form.referenceFrequency = (
          this.form.referenceFrequency / 60
        )
      } else {
        this.form.referenceFrequency = (
          this.form.referenceFrequency * 60
        )
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1000px) {
  .point-container {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.el-row {
  display: block;
}

img.sensorAxis {
  height: 200px;
  margin: 0 auto;
  width: auto !important;
}

.el-collapse-item__header {
  height: 10px;
}
.bearing-form .el-form-item {
  margin-bottom: 5px;
}

.bearing-form .el-form-item__label {
  line-height: 10px;
}
.el-input {
  width: 200px;
}
.el-select {
  width: 200px;
}
.el-radio-group {
  margin-left: 5%;
}

input[type="file"] {
  width: 90px;
  color: transparent;
}
</style>
<style>
.image-slot {
  width: 200px;
  height: 195px;
  border: 1px dashed gray;
}
</style>